module.exports = __webpack_public_path__ + "static/media/ic_reload_gray.4b6809bb.svg";